<template>
  <div class="title-block">
    {{ $t("app.archiveModal.text") }}
    <span class="primary-color bold" v-text="props.data.campaign.internal_name" />
    ?
  </div>
  <p class="under-text">
    {{ $t("app.archiveModal.info") }}
  </p>
  <div class="btn-container">
    <Button class="secondary outline sm" :label="$t('app.archiveModal.buttons.cancel')" @click="emits('close')" />
    <Button class="primary sm" :label="$t('app.archiveModal.buttons.archive')" :loading="state.btnIsLoading" @click="archive()" />
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";
import ToastContent from "@/components/global/ToastContent.vue";
import { Campaign } from "@/types/campaign";
import { useArchiveCampaign } from "@/queries/campaigns.query";

const { mutateAsync: archiveCampaign } = useArchiveCampaign();

const emits = defineEmits(["close", "confirm"]);

const route = useRoute();
const toast = useToast();
const { t } = useI18n();

const state = reactive({
  btnIsLoading: false,
});

const props = defineProps<{
  data: Campaign,
}>();

async function archive() {
  state.btnIsLoading = true;

  await archiveCampaign({
    organisationId: route.params.companyId as string,
    spaceId: route.params.spaceId as string,
    campaignId: props.data.id,
  }, {
    onSuccess: () => {
      toast.success(t("app.archiveModal.toast.success"));
    },
    onError: (error) => {
      toast.error(error);
    }
  })

  emits("confirm");

  state.btnIsLoading = false;
}
</script>
